import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { addMinutes, subMinutes } from 'date-fns';
import { utc } from '@date-fns/utc';

const tzOffset = (op: Function) => (dateObj: Date) => op(dateObj, dateObj.getTimezoneOffset());
const subTzOffset = tzOffset(subMinutes);
const addTzOffset = tzOffset(addMinutes);


export class CustomDateAdapter extends DateFnsAdapter {
  override getFirstDayOfWeek(): number {
    return 1; // Monday
  }

  override createDate(year: number, month: number, date: number): Date {
    return utc(subTzOffset(super.createDate(year, month, date)));
  }

  override today(): Date {
    return utc(subTzOffset(super.today()));
  }

  override toIso8601(date: Date): string {
    return date.toISOString();
  }

  override deserialize(value: any): Date | null {
    const parsed = super.deserialize(value);
    return parsed ? utc(subTzOffset(parsed)) : null;
  }

  override parse(value: unknown, parseFormat: string | string[]): Date | null {
    const parsed = super.parse(value, parseFormat);
    return parsed ? utc(subTzOffset(parsed)) : null;
  }

  override format(date: Date, displayFormat: string): string {
    return super.format(date, displayFormat)
  }
}
